import Image from 'next/image';
import Link from 'next/link';

function BuySubscriptionBanner() {
    return (
        <Link href={'/subscription'}>
            <div className='relative aspect-[354/132] w-full'>
                <Image src='/assets/banner/buy-sub-banner.png' alt='buy-sub-banner' fill className='object-cover' />
            </div>
        </Link>
    );
}

export default BuySubscriptionBanner;

